<template>
	<div class="pa-2">
		<div class="mb-4">
			<v-breadcrumbs
				divider="/"
				:items="[
					{
						text: 'الدوام',
						to: { name: 'attendance' },
					},
					{
						text: 'الدوام',
						to: { name: 'attendance' },
					},
				]">
			</v-breadcrumbs>
			<customizable-table
				:headers="WorkAttendanceHeaders"
				localStorageName="attendance.work">
				<template v-slot:default="{ headers, openCustomizer }">
					<bee-handy-table
						:headers="headers"
						:data-table-props="{ disableSort: true }"
						hide-default-footer
						dense>
						<template v-slot:no-data><div></div></template>
						<template v-slot:top="{}">
							<v-btn
								style="z-index: 3"
								class="me-n2"
								left
								absolute
								@click="openCustomizer"
								x-small
								depressed>
								تعديل
							</v-btn>
						</template>
					</bee-handy-table>
				</template>
			</customizable-table>
		</div>

		<div class="mb-4">
			<v-breadcrumbs
				divider="/"
				:items="[
					{
						text: 'الموظفين',
						to: { name: 'employees' },
					},
					{
						text: 'موظف',
						disabled: true,
					},
					{
						text: 'العمل والداوم',
						disabled: true,
					},
					{
						text: 'الدوام',
						disabled: true,
					},
				]">
			</v-breadcrumbs>
			<customizable-table
				:headers="WorkEmployeeAttendanceHeaders"
				localStorageName="employee.attendance.work">
				<template v-slot:default="{ headers, openCustomizer }">
					<bee-handy-table
						:headers="headers"
						:data-table-props="{ disableSort: true }"
						hide-default-footer
						dense>
						<template v-slot:no-data><div></div></template>
						<template v-slot:top="{}">
							<v-btn
								style="z-index: 3"
								class="me-n2"
								left
								absolute
								@click="openCustomizer"
								x-small
								depressed>
								تعديل
							</v-btn>
						</template>
					</bee-handy-table>
				</template>
			</customizable-table>
		</div>

		<div class="mb-4">
			<v-breadcrumbs
				divider="/"
				:items="[
					{
						text: 'الموظفين',
						to: { name: 'employees' },
					},
					{
						text: 'المتقدمين',
						disabled: true,
					},
				]">
			</v-breadcrumbs>
			<customizable-table
				:headers="applicantsHeaders"
				localStorageName="employees.applicants">
				<template v-slot:default="{ headers, openCustomizer }">
					<bee-handy-table
						:headers="headers"
						:data-table-props="{ disableSort: true }"
						hide-default-footer
						dense>
						<template v-slot:no-data><div></div></template>
						<template v-slot:top="{}">
							<v-btn
								style="z-index: 3"
								class="me-n2"
								left
								absolute
								@click="openCustomizer"
								x-small
								depressed>
								تعديل
							</v-btn>
						</template>
					</bee-handy-table>
				</template>
			</customizable-table>
		</div>

		<div class="mb-4">
			<v-breadcrumbs
				divider="/"
				:items="[
					{
						text: 'الموظفين',
						to: { name: 'employees' },
					},
					{
						text: 'المؤقتين',
						disabled: true,
					},
				]">
			</v-breadcrumbs>
			<customizable-table
				:headers="temporariesHeaders"
				localStorageName="employees.temporaries">
				<template v-slot:default="{ headers, openCustomizer }">
					<bee-handy-table
						:headers="headers"
						:data-table-props="{ disableSort: true }"
						hide-default-footer
						dense>
						<template v-slot:no-data><div></div></template>
						<template v-slot:top="{}">
							<v-btn
								style="z-index: 3"
								class="me-n2"
								left
								absolute
								@click="openCustomizer"
								x-small
								depressed>
								تعديل
							</v-btn>
						</template>
					</bee-handy-table>
				</template>
			</customizable-table>
		</div>

		<div class="mb-4">
			<v-breadcrumbs
				divider="/"
				:items="[
					{
						text: 'الموظفين',
						to: { name: 'employees' },
					},
					{
						text: 'المثبتين',
						disabled: true,
					},
				]">
			</v-breadcrumbs>
			<customizable-table
				:headers="currentlyHeaders"
				localStorageName="employees.currently">
				<template v-slot:default="{ headers, openCustomizer }">
					<bee-handy-table
						:headers="headers"
						:data-table-props="{ disableSort: true }"
						hide-default-footer
						dense>
						<template v-slot:no-data><div></div></template>
						<template v-slot:top="{}">
							<v-btn
								style="z-index: 3"
								class="me-n2"
								left
								absolute
								@click="openCustomizer"
								x-small
								depressed>
								تعديل
							</v-btn>
						</template>
					</bee-handy-table>
				</template>
			</customizable-table>
		</div>

		<div class="mb-4">
			<v-breadcrumbs
				divider="/"
				:items="[
					{
						text: 'الموظفين',
						to: { name: 'employees' },
					},
					{
						text: 'السابقين',
						disabled: true,
					},
				]">
			</v-breadcrumbs>
			<customizable-table
				:headers="formerHeaders"
				localStorageName="employees.former">
				<template v-slot:default="{ headers, openCustomizer }">
					<bee-handy-table
						:headers="headers"
						:data-table-props="{ disableSort: true }"
						hide-default-footer
						dense>
						<template v-slot:no-data><div></div></template>
						<template v-slot:top="{}">
							<v-btn
								style="z-index: 3"
								class="me-n2"
								left
								absolute
								@click="openCustomizer"
								x-small
								depressed>
								تعديل
							</v-btn>
						</template>
					</bee-handy-table>
				</template>
			</customizable-table>
		</div>

		<div class="mb-4">
			<v-breadcrumbs
				divider="/"
				:items="[
					{
						text: 'الموظفين',
						to: { name: 'employees' },
					},
					{
						text: 'الكل',
						disabled: true,
					},
				]">
			</v-breadcrumbs>
			<customizable-table
				:headers="allEmployeeHeaders"
				localStorageName="employees.all">
				<template v-slot:default="{ headers, openCustomizer }">
					<bee-handy-table
						:headers="headers"
						:data-table-props="{ disableSort: true }"
						hide-default-footer
						dense>
						<template v-slot:no-data><div></div></template>
						<template v-slot:top="{}">
							<v-btn
								style="z-index: 3"
								class="me-n2"
								left
								absolute
								@click="openCustomizer"
								x-small
								depressed>
								تعديل
							</v-btn>
						</template>
					</bee-handy-table>
				</template>
			</customizable-table>
		</div>
	</div>
</template>

<script>
import { DATE_FORMAT, TIME_FORMAT } from '@/utils/moment';
import moment from 'moment';
export default {
	name: 'DefaultTableHeaders',

	data() {
		return {
			WorkAttendanceHeaders: [
				{ text: '', value: 'type', name: 'type', sortable: false, width: 0, cellClass: 'pe-0 ps-2' },
				{
					text: this.$T('headers.employee-name'),
					value: 'name',
					name: 'employee',
					cellClass: 'ps-0',
				},
				{ text: this.$T('headers.section-name'), value: 'section', name: 'section' },
				{
					text: this.$T('headers.date'),
					type: 'date',
					dateFormat: DATE_FORMAT,
					value: 'date',
					name: 'date',
				},
				{
					text: this.$T('headers.attendance.firstFinderPrint'),
					value: 'arrivalTime',
					name: 'startTime',
					noNotAvailableText: false,
					setValueExpr: (value, index) =>
						moment(value).isValid() ? moment(value).format(TIME_FORMAT) : '-',
				},
				{
					text: this.$T('headers.attendance.lastFinderPrint'),
					value: 'departureTime',
					name: 'endTime',
					setValueExpr: (value, index) =>
						moment(value).isValid() ? moment(value).format(TIME_FORMAT) : '-',
				},
				{
					text: this.$T('headers.attendance.duration'),
					value: 'duration',
					name: 'duration',
				},
				{
					text: this.$T('headers.attendance.delay'),
					value: 'delayArrivalInMinute',
					name: 'delay',
				},
				{
					text: this.$T('headers.attendance.earlyLeave'),
					value: 'earlyGoInMinute',
					name: 'earlyLeave',
				},
				{
					text: this.$T('headers.attendance.extraTotal'),
					value: 'overTimeInMinute',
					name: 'extra',
				},

				{
					text: this.$T('headers.attendance.fingerPrintCount'),
					value: 'fingerPrintCount',
					name: 'fingerPrintCount',
				},
				{
					text: this.$T('headers.attendance.unjustifiedTime'),
					value: 'unjustifiedTime',
					name: 'unjustifiedTime',
				},
				{
					text: this.$T('headers.attendance.durationToAll'),
					value: 'durationToAll',
					name: 'durationToAll',
				},
				{
					text: this.$T('headers.attendance.earlyLeaveToVacation'),
					value: 'earlyLeaveToVacation',
					name: 'earlyLeaveToVacation',
				},
				{
					text: this.$T('headers.attendance.lateArriveFromVacation'),
					value: 'lateArriveFromVacation',
					name: 'lateArriveFromVacation',
				},
				{
					text: this.$T('headers.attendance.vacationOverTime'),
					value: 'vacationOverTime',
					name: 'vacationOverTime',
				},
				{
					text: this.$T('headers.attendance.extraBefore'),
					value: 'extraBefore',
					name: 'extraBefore',
				},
				{
					text: this.$T('headers.attendance.extraAfter'),
					value: 'extraAfter',
					name: 'extraAfter',
				},
				{
					text: this.$T('headers.attendance.extraVacation'),
					value: 'extraVacation',
					name: 'extraVacation',
				},
			],

			WorkEmployeeAttendanceHeaders: [
				{ text: '', value: 'type', name: 'type', sortable: false, width: 0, cellClass: 'pe-0 ps-2' },
				{ text: this.$T('headers.section-name'), value: 'section', name: 'section' },
				{
					text: this.$T('headers.date'),
					type: 'date',
					dateFormat: DATE_FORMAT,
					value: 'date',
					name: 'date',
				},
				{
					text: this.$T('headers.attendance.firstFinderPrint'),
					value: 'arrivalTime',
					name: 'arrivalTime',
					noNotAvailableText: false,
					setValueExpr: (value, index) =>
						moment(value).isValid() ? moment(value).format(TIME_FORMAT) : '-',
				},
				{
					text: this.$T('headers.attendance.lastFinderPrint'),
					value: 'departureTime',
					name: 'departureTime',
					setValueExpr: (value, index) =>
						moment(value).isValid() ? moment(value).format(TIME_FORMAT) : '-',
				},
				{
					text: this.$T('headers.attendance.duration'),
					value: 'duration',
					name: 'duration',
				},
				{
					text: this.$T('headers.attendance.delay'),
					value: 'delayArrivalInMinute',
					name: 'delay',
				},
				{
					text: this.$T('headers.attendance.earlyLeave'),
					value: 'earlyGoInMinute',
					name: 'earlyLeave',
				},
				{
					text: this.$T('headers.attendance.extraTotal'),
					value: 'overTimeInMinute',
					name: 'extra',
				},

				{
					text: this.$T('headers.attendance.fingerPrintCount'),
					value: 'fingerPrintCount',
					name: 'fingerPrintCount',
				},
				{
					text: this.$T('headers.attendance.unjustifiedTime'),
					value: 'unjustifiedTime',
					name: 'unjustifiedTime',
				},
				{
					text: this.$T('headers.attendance.durationToAll'),
					value: 'durationToAll',
					name: 'durationToAll',
				},
				{
					text: this.$T('headers.attendance.earlyLeaveToVacation'),
					value: 'earlyLeaveToVacation',
					name: 'earlyLeaveToVacation',
				},
				{
					text: this.$T('headers.attendance.lateArriveFromVacation'),
					value: 'lateArriveFromVacation',
					name: 'lateArriveFromVacation',
				},
				{
					text: this.$T('headers.attendance.vacationOverTime'),
					value: 'vacationOverTime',
					name: 'vacationOverTime',
				},
				{
					text: this.$T('headers.attendance.extraBefore'),
					value: 'extraBefore',
					name: 'extraBefore',
				},
				{
					text: this.$T('headers.attendance.extraAfter'),
					value: 'extraAfter',
					name: 'extraAfter',
				},
				{
					text: this.$T('headers.attendance.extraVacation'),
					value: 'extraVacation',
					name: 'extraVacation',
				},
			],

			allEmployeeHeaders: [
				{
					text: this.$T('headers.code'),
					name: 'code',
					value: 'code',
					width: 0,
					class: 'pe-0 ps-1',
					cellClass: 'pe-0 ps-1',
				},
				{ text: this.$T('headers.employee-name'), name: 'name', value: 'name' },
				{ text: this.$T('headers.employees.mobile'), name: 'phone', value: 'phone', sortable: false },
				{ text: this.$T('headers.employees.email'), name: 'email', value: 'email', sortable: false },
				{
					text: this.$T('headers.employees.formDate'),
					name: 'formDate',
					value: 'formDate',
					type: 'date',
					dateFormat: DATE_FORMAT,
					sortable: false,
				},
				{
					text: this.$T('headers.employees.startDate'),
					name: 'startDate',
					value: 'startDate',
					type: 'date',
					dateFormat: DATE_FORMAT,
					sortable: false,
				},
				{
					text: this.$T('headers.employees.duration'),
					name: 'duration',
					value: 'duration',
					sortable: false,
				},
			],
			applicantsHeaders: [
				{
					text: this.$T('headers.code'),
					name: 'code',
					value: 'code',
					width: 0,
					class: 'pe-0 ps-1',
					cellClass: 'pe-0 ps-1',
				},
				{ text: this.$T('headers.employee-name'), name: 'name', value: 'name' },
				{ text: this.$T('headers.employees.mobile'), name: 'phone', value: 'phone', sortable: false },
				{ text: this.$T('headers.employees.email'), name: 'email', value: 'email', sortable: false },
				{
					text: this.$T('headers.employees.formDate'),
					name: 'formDate',
					value: 'formDate',
					type: 'date',
					dateFormat: DATE_FORMAT,
					sortable: false,
				},
				{
					text: this.$T('headers.employees.startDate'),
					name: 'startDate',
					value: 'startDate',
					type: 'date',
					dateFormat: DATE_FORMAT,
					sortable: false,
				},
				{
					text: this.$T('headers.employees.duration'),
					name: 'duration',
					value: 'duration',
					sortable: false,
				},
			],
			temporariesHeaders: [
				{
					text: this.$T('headers.code'),
					name: 'code',
					value: 'code',
					width: 0,
					class: 'pe-0 ps-1',
					cellClass: 'pe-0 ps-1',
				},
				{ text: this.$T('headers.employee-name'), name: 'name', value: 'name' },
				{ text: 'القسم', name: 'section', value: 'section', sortable: false },
				{
					text: 'المسمى',
					name: 'role',
					value: 'role',
					setValueExpr: (v) => {
						if (!this.positions || !this.positions.length) return null;

						return this.positions.find((e) => e.id === v)?.name;
					},
					sortable: false,
				},
				{ text: this.$T('headers.employees.mobile'), name: 'phone', value: 'phone', sortable: false },
				{ text: this.$T('headers.employees.email'), name: 'email', value: 'email', sortable: false },
				{
					text: this.$T('headers.employees.formDate'),
					name: 'formDate',
					value: 'formDate',
					type: 'date',
					dateFormat: DATE_FORMAT,
					sortable: false,
				},
				{
					text: this.$T('headers.employees.startDate'),
					name: 'startDate',
					value: 'startDate',
					type: 'date',
					dateFormat: DATE_FORMAT,
					sortable: false,
				},
				{
					text: this.$T('headers.employees.duration'),
					name: 'duration',
					value: 'duration',
					sortable: false,
				},
			],
			currentlyHeaders: [
				{
					text: this.$T('headers.code'),
					name: 'code',
					value: 'code',
					width: 0,
					class: 'pe-0 ps-1',
					cellClass: 'pe-0 ps-1',
				},
				{ text: this.$T('headers.employee-name'), name: 'name', value: 'name' },
				{ text: 'القسم', name: 'section', value: 'section', sortable: false },
				{
					text: 'المسمى',
					name: 'role',
					value: 'role',
					setValueExpr: (v) => {
						if (!this.positions || !this.positions.length) return null;

						return this.positions.find((e) => e.id === v)?.name;
					},
					sortable: false,
				},
				{ text: this.$T('headers.employees.mobile'), name: 'phone', value: 'phone', sortable: false },
				{ text: this.$T('headers.employees.email'), name: 'email', value: 'email', sortable: false },
				{
					text: this.$T('headers.employees.formDate'),
					name: 'formDate',
					value: 'formDate',
					type: 'date',
					dateFormat: DATE_FORMAT,
					sortable: false,
				},
				{
					text: this.$T('headers.employees.startDate'),
					name: 'startDate',
					value: 'startDate',
					type: 'date',
					dateFormat: DATE_FORMAT,
					sortable: false,
				},
				{
					text: this.$T('headers.employees.duration'),
					name: 'duration',
					value: 'duration',
					sortable: false,
				},
			],
			formerHeaders: [
				{
					text: this.$T('headers.code'),
					name: 'code',
					value: 'code',
					width: 0,
					class: 'pe-0 ps-1',
					cellClass: 'pe-0 ps-1',
				},
				{ text: this.$T('headers.employee-name'), name: 'name', value: 'name' },
				{ text: this.$T('headers.employees.mobile'), name: 'phone', value: 'phone', sortable: false },
				{ text: this.$T('headers.employees.email'), name: 'email', value: 'email', sortable: false },
				{
					text: this.$T('headers.employees.formDate'),
					name: 'formDate',
					value: 'formDate',
					type: 'date',
					dateFormat: DATE_FORMAT,
					sortable: false,
				},
				{
					text: this.$T('headers.employees.startDate'),
					name: 'startDate',
					value: 'startDate',
					type: 'date',
					dateFormat: DATE_FORMAT,
					sortable: false,
				},
				{
					text: this.$T('headers.employees.duration'),
					name: 'duration',
					value: 'duration',
					sortable: false,
				},
			],
		};
	},
};
</script>

<style></style>
